import React, { useEffect, useRef } from 'react';

let empWidgetInstance = null as any;

export const updateWidgetProps = ({ widgetName, ...widgetProps }) => {
  try {
    if (!empWidgetInstance) {
      empWidgetInstance = window.conviva.microProps?.loadEmpWidget?.('#__emp_widget__', '', {});
      empWidgetInstance?.mountPromise
        ?.then(() => {
          updateWidgetProps({ widgetName, ...widgetProps });
        })
        .catch(() => {
          // do nothing
        });
      return;
    }
    if (empWidgetInstance.getStatus() === 'MOUNTED') {
      empWidgetInstance?.mountPromise?.then(() => {
        empWidgetInstance
          ?.update?.({
            widgetName,
            widgetProps,
          })
          .catch(() => {
            // do nothing
          });
      });
    }
  } catch (e) {
    console.log('emp widget error:', e);
  }
};

export const EMPWidgetContainer: React.FC = () => {
  const containerRef = useRef<any>(null);

  useEffect(() => {
    // prefetch
    updateWidgetProps({ widgetName: '' });
    return () => {
      if (empWidgetInstance) {
        empWidgetInstance.mountPromise
          ?.then(() => {
            empWidgetInstance.unmount?.();
          })
          .catch(() => {
            // do nothing
          });
      }
    };
  }, []);

  return <div id="__emp_widget__" ref={containerRef} />;
};
